import { j as o } from "./kezios-design-system.esm172.js";
import { Stack as n, Flex as s } from "@mantine/core";
import { SectionLayout as a } from "./kezios-design-system.esm96.js";
import { SectionHeader as c } from "./kezios-design-system.esm125.js";
import { Item as x } from "./kezios-design-system.esm190.js";
import { Spacing as r } from "./kezios-design-system.esm135.js";
const f = ({
  children: m,
  category: t = void 0,
  title: e = void 0,
  subtitle: i = void 0,
  ...p
}) => /* @__PURE__ */ o.jsx(a, { ...p, children: /* @__PURE__ */ o.jsxs(n, { gap: r.s16, children: [
  (e || t || i) && /* @__PURE__ */ o.jsx(
    c,
    {
      category: t,
      title: e,
      subtitle: i,
      titleComponent: "h2"
    }
  ),
  /* @__PURE__ */ o.jsx(
    s,
    {
      wrap: "wrap",
      rowGap: r.s16,
      gap: r.s8,
      justify: "center",
      children: m
    }
  )
] }) });
f.Item = x;
export {
  f as FeatureSection
};
